import { makeStyles } from "@mui/styles";
import { SURVEY_SPACING, SURVEY_MIXINS } from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const useMCQQuestionStyles = makeStyles(() => ({
  container: {
    marginTop: SURVEY_SPACING.QUESTION_MARGIN_TOP,
  },
  formLabel: {
    paddingBottom: SURVEY_SPACING.LABEL_PADDING_BOTTOM,
  },
  questionText: SURVEY_MIXINS.questionLabel,
  requiredAsterisk: SURVEY_MIXINS.requiredAsterisk,
  optionLabel: SURVEY_MIXINS.optionLabel,
  radioGroupError: SURVEY_MIXINS.errorBorder,
  errorBorder: SURVEY_MIXINS.errorBorder,
}));
